module.exports = __webpack_public_path__ + "static/media/showhide.f1a5ccf9.svg";